module.exports = __webpack_public_path__ + "static/Boydo-Aiming-web-9745ccb4d1c7b77587c6e3706b6959a2.jpg";